import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { db } from '../../services/db';
import Button from '../../components/common/Button';
import SafeIcon from '../../components/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const HeroEditor = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    const data = await db.getHeroContent();
    setContent(data);
  };

  const handleChange = (field, value) => {
    setContent(prev => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        handleChange('backgroundImage', reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    await db.updateHeroContent(content);
    setSaving(false);
    setSuccess(true);
    setTimeout(() => setSuccess(false), 3000);
  };

  if (!content) return <AdminLayout><div>Loading...</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className="max-w-4xl">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 space-y-6">
          {/* Spanish Headline */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Spanish Headline
            </label>
            <input
              type="text"
              value={content.titleEs}
              onChange={(e) => handleChange('titleEs', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* English Headline */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              English Headline
            </label>
            <input
              type="text"
              value={content.titleEn}
              onChange={(e) => handleChange('titleEn', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* Spanish Subtitle */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Spanish Subtitle
            </label>
            <textarea
              value={content.subtitleEs}
              onChange={(e) => handleChange('subtitleEs', e.target.value)}
              rows={3}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* English Subtitle */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              English Subtitle
            </label>
            <textarea
              value={content.subtitleEn}
              onChange={(e) => handleChange('subtitleEn', e.target.value)}
              rows={3}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* Background Image */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Hero Background Image
            </label>
            {content.backgroundImage && (
              <div className="mb-4 relative group">
                <img
                  src={content.backgroundImage}
                  alt="Hero background"
                  className="w-full h-48 object-cover rounded-lg"
                />
                <button
                  onClick={() => handleChange('backgroundImage', '')}
                  className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <SafeIcon icon={FiIcons.FiTrash2} />
                </button>
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
            <p className="text-xs text-gray-500 mt-1">Recommended: 1920x1080px</p>
          </div>

          {/* Stats Number */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Community Stats Number
            </label>
            <input
              type="text"
              value={content.statsNumber}
              onChange={(e) => handleChange('statsNumber', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
              placeholder="e.g., 5,000+"
            />
          </div>

          {/* Stats Text Spanish */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Stats Text (Spanish)
            </label>
            <input
              type="text"
              value={content.statsTextEs}
              onChange={(e) => handleChange('statsTextEs', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* Stats Text English */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">
              Stats Text (English)
            </label>
            <input
              type="text"
              value={content.statsTextEn}
              onChange={(e) => handleChange('statsTextEn', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent outline-none"
            />
          </div>

          {/* Save Button */}
          <div className="flex items-center gap-4 pt-4 border-t">
            <Button onClick={handleSave} disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </Button>
            {success && (
              <div className="flex items-center gap-2 text-green-600">
                <SafeIcon icon={FiIcons.FiCheck} />
                <span className="text-sm font-medium">Saved successfully!</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default HeroEditor;